import Vue from 'vue'
import TopContainer from './General/TopContainer'
// import Col2WithInfoBox from './Col2WithInfoBox'
// import InfoBox from './InfoBox'

Vue.component('ais-footer', (resolve) => {
  import('./General/Footer.vue')
    .then((AISFooter) => {
      resolve(AISFooter.default)
    })
})

Vue.component('top-container', TopContainer)

Vue.component('simple-page', (resolve) => {
  import('./General/SimplePage.vue')
    .then((SimplePage) => {
      resolve(SimplePage.default)
    })
})

Vue.component('col-2-with-movie', (resolve) => {
  import('./Fa/Col2WithMovie.vue')
    .then((Col2WithMovie) => {
      resolve(Col2WithMovie.default)
    })
})

Vue.component('col-2-with-infobox', (resolve) => {
  import('./Fa/Col2WithInfoBox.vue')
    .then((Col2WithInfoBox) => {
      resolve(Col2WithInfoBox.default)
    })
})

Vue.component('infobox', (resolve) => {
  import('./Fa/InfoBox.vue')
    .then((InfoBox) => {
      resolve(InfoBox.default)
    })
})

Vue.component('col-1', (resolve) => {
  import('./General/Col1.vue')
    .then((Col1) => {
      resolve(Col1.default)
    })
})

Vue.component('col-3', (resolve) => {
  import('./Fa/Col3.vue')
    .then((Col3) => {
      resolve(Col3.default)
    })
})

Vue.component('col-2', (resolve) => {
  import('./General/PageCol2.vue')
    .then((PageCol2) => {
      resolve(PageCol2.default)
    })
})

Vue.component('page-with-scrollspy', (resolve) => {
  import('./General/PageWithScrollSpy.vue')
    .then((PageWithScrollSpy) => {
      resolve(PageWithScrollSpy.default)
    })
})

Vue.component('col-3-with-forms', (resolve) => {
  import('./Fa/Col3WithForms.vue')
    .then((Col3WithForms) => {
      resolve(Col3WithForms.default)
    })
})

// Vue.component('navigation', (resolve) => {
//   import('./Navigation.vue')
//     .then((Navigation) => {
//       resolve(Navigation.default)
//     })
// })

Vue.component('col-2-graduate-left', (resolve) => {
  import('./Fa/Col2GraduatePhotoLeft.vue')
    .then((Col2GraduatePhotoLeft) => {
      resolve(Col2GraduatePhotoLeft.default)
    })
})

Vue.component('col-2-graduate-right', (resolve) => {
  import('./Fa/Col2GraduatePhotoRight.vue')
    .then((Col2GraduatePhotoRight) => {
      resolve(Col2GraduatePhotoRight.default)
    })
})
